import React from 'react';
import type { FC } from 'react';

import { Redirection } from './Redirection';
import type { RedirectionProps } from './Redirection';

/**
 * Delays the redirection on the client side
 * When SSR found redirection is needed, it will store the information in window.__DELAYED_CONTENT_REDIRECTION__
 * When SPA starts to render route, it can use the information in window.__DELAYED_CONTENT_REDIRECTION__
 * to fix necessary states early to prevent unnecessary re-render, and do the redirection in client side if still needed.
 * @param props The redirection props.
 */
export const DelayRedirectionOnClient: FC<RedirectionProps> = (props) => {
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (process.env.REACT_SSR) {
		window.__DELAYED_CONTENT_REDIRECTION__ = {
			contentSlug: props.params?.contentSlug,
		};
		return null;
	} else {
		// In client-side rendering, we can directly render the Redirection component
		return <Redirection {...props} />;
	}
};
